import React, { useRef } from "react";
import { Button, Card, Icon } from "semantic-ui-react";
import ContentEditorOrganTips from "./ContentEditorOrganTips";
import "suneditor/dist/css/suneditor.min.css";
import { ORGAN_TIPS } from "./sequence/SegmentTarget";

type CardSegementOrganTypeProps = {
  setProp: any;
  runSequence: any;
  SegmentTargetSequence: any;
  setModalParam: any;
  optionsOrgans: any[];
};

const CardSegmentOrgan = (props: CardSegementOrganTypeProps) => {
  const extra = (
    <a>
      <Icon name="user" />
      16 Friends
    </a>
  );

  return (
    <div style={{ height: "100%", width: "100%", overflow: "scrollY" }}>
      <div style={{ display: "flex", justifyContent: "flex-end", padding: "3px 0px" }}>
        <Button
          size="tiny"
          color="pink"
          icon
          labelPosition="left"
          onClick={() => {
            props.runSequence({
              sequence: "SegmentTarget",
              action: "AddContent",
              type: ORGAN_TIPS,
            });
          }}
        >
          <Icon name="plus" />
          เพิ่มอวัยวะ
        </Button>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
        {props.SegmentTargetSequence.organTips?.map((item, idx) => (
          <ContentEditorOrganTips
            key={item?.id}
            id={item?.id}
            version={item?.version}
            errorField={null}
            isEdit={item.isEdit}
            publishedAt={item.published_at}
            publishedVersion={item.published_version}
            organ={item.organ}
            content={item.content || ""}
            suggestionLabs={item.suggestion_labs}
            updatedAt={item.updated_at}
            updatedBy={item.updated_by}
            idxPublishLoading={props.SegmentTargetSequence?.idxPublishLoading}
            idxUnpublishLoading={props.SegmentTargetSequence?.idxUnpublishLoading}
            idxSaveLoading={props.SegmentTargetSequence?.idxSaveLoading}
            setModalParam={props.setModalParam}
            publishJson={props.SegmentTargetSequence?.publishJson}
            optionsSuggestLab={[
              { key: "Chest X-Ray", value: "เอกซเรย์ปอดและทรวงอก", text: "เอกซเรย์ปอดและทรวงอก" },
              { key: "EKG", value: "ตรวจคลื่นไฟฟ้าหัวใจ", text: "ตรวจคลื่นไฟฟ้าหัวใจ" },
              {
                key: "Complete Blood Count",
                value: "ตรวจความสมบูรณ์เม็ดเลือด",
                text: "ตรวจความสมบูรณ์เม็ดเลือด",
              },
              {
                key: "Glucose - Fasting",
                value: "ตรวจระดับน้ำตาลในเลือด",
                text: "ตรวจระดับน้ำตาลในเลือด",
              },
              {
                key: "Glycated Hb - HbA1c",
                value: "ตรวจการสะสมน้ำตาลในเลือด",
                text: "ตรวจการสะสมน้ำตาลในเลือด",
              },
              {
                key: "Kidney Function Test",
                value: "ตรวจการทำงานของไต",
                text: "ตรวจการทำงานของไต",
              },
              {
                key: "Liver Function Test",
                value: "ตรวจการทำงานของตับ",
                text: "ตรวจการทำงานของตับ",
              },
              { key: "Lipid Profile", value: "ตรวจไขมันในเลือด", text: "ตรวจไขมันในเลือด" },
              { key: "Urine Examination", value: "ตรวจปัสสาวะ", text: "ตรวจปัสสาวะ" },
              {
                key: "BMD Whole Body",
                value: "ตรวจความหนาแน่นของกระดูก",
                text: "ตรวจความหนาแน่นของกระดูก",
              },
              { key: "Uric Acid", value: "ตรวจกรดยูริค", text: "ตรวจกรดยูริค" },
              { key: "Vitamin D", value: "ตรวจระดับวิตามินดี", text: "ตรวจระดับวิตามินดี" },
              {
                key: "Thyroid Stimulating Hormone (TSH)",
                value: "ตรวจการทำงานของต่อมไทยรอยด์",
                text: "ตรวจการทำงานของต่อมไทยรอยด์",
              },
              {
                key: "Alpha-fetoprotien (AFP)",
                value: "ตรวจหามะเร็งในตับ",
                text: "ตรวจหามะเร็งในตับ",
              },
              { key: "PSA", value: "ตรวจมะเร็งต่อมลูกหมาก", text: "ตรวจมะเร็งต่อมลูกหมาก" },
              { key: "Stool Examination", value: "ตรวจอุจจาระ", text: "ตรวจอุจจาระ" },
            ]}
            optionsOrgans={props.optionsOrgans}
            runSequence={props.runSequence}
          />
        ))}
      </div>
    </div>
  );
};

export default CardSegmentOrgan;
